import { DatePicker } from "antd"
import dayjs from "dayjs"

export const BaseDatePicker = ({ type=undefined, value, format='YYYY-MM-DD', allowClear=true, inputReadOnly=true, suffixIcon=null, disabled=undefined, onChange=()=>{}, style=null }) => {
  // YYYY-MM-DD 또는 YYYY-MM-DD HH:mm:ss 형식만 허용하는 정규식
  const regex = /^(?:\d{4}-\d{2}-\d{2}(?: \d{2}:\d{2}:\d{2})?)|(?:\d{4}-\d{2}-\d{2})|(?:\d{4}-\d{2})$/;
  const handleChange = (date, dateString) => {
    if (onChange) {
      // onChange(date.format('YYYY-MM-DD HH:mm:ss'))
      onChange(dateString)
    }
  }

  return (
    <DatePicker
      value={regex.test(value) ? dayjs(value) : undefined }
      format={format}
      allowClear={allowClear}
      inputReadOnly={inputReadOnly}
      suffixIcon={suffixIcon}
      disabled={disabled}
      style={{width: '12rem', textAlignLast: 'center', ...style}}
      onChange={handleChange}
      picker={type}
    />
  )
}